import React, { useEffect } from 'react';
import IconQilu from '@/images/h5-common/logo.webp';
import IconHanzi from '@/images/h5-common/logo_hanzi.webp';
import { isHanziApp } from '@/utils/EnvUtils';
import { JsBridge } from '@/utils/JsBridge';

const HANZI_PAGE_TITLE = '天才鸭汉字';
const SDUCK_PAGE_TITLE = '关于我们';

const HANZI_INTRO = (
  <>
    「天才鸭汉字」是一款专为汉字学习定制的互动体验软件，它结合识字、听写、组词与复习计划，配合 AI
    辅助与趣味练习，帮助大家在轻松探索中掌握汉字读写与词组运用。我们致力于打破传统的汉字学习方式，让过程更加生动和高效。
    <br />
    <br />
    【系统化汉字学习】
    提供按课表推进的识字、听写、组词与复习任务，配合艾宾浩斯记忆曲线，帮助大家稳步积累、及时巩固。
    <br />
    <br />
    【多样化互动练习】
    包含听写挑战、组词训练、国学阅读等多种互动形式，在练习中加深对字形、字音与字义的理解。
    <br />
    <br />
    【智能学习助手】
    内置 AI 辅助与个性化推荐，可根据学习进度调整每日任务，让汉字学习更有节奏、更高效。
    <br />
    <br />
  </>
);

const SDUCK_INTRO = (
  <>
    「天才鸭」是一款专为英语学习的定制的互动体验软件，它利用创新技术和 AI
    辅助发音工具，创造了一个轻松愉悦的环境，帮助大家在探索中拓展英语能力。我们致力于打破传统的语言训练方式，让过程更加生动和高效。
    <br />
    <br />
    【多样化互动体验】
    我们提供了一系列互动体验，包括词卡记忆游戏、拼写挑战、听力填空等，这些游戏化的方式不仅能够激发大家的好奇心，还能有效加强大家的语言感知能力。
    <br />
    <br />
    【个性化拓展计划】
    利用智能算法，我们为大家定制了个性化的拓展计划，确保大家在探索过程中既有序又高效，帮助大家逐步建立起坚实的语言基础。
    <br />
    <br />
    【智能 AI 助手】
    我们的 App 内置了 AI 发音辅助功能，能够提供即时的发音反馈。无论是单个音节还是完整句子，智能 AI
    助手都能协助大家改善发音，提升语言的自然度。
    <br />
    <br />
  </>
);

function AboutApp() {
  const hanziApp = isHanziApp();
  const pageTitle = hanziApp ? HANZI_PAGE_TITLE : SDUCK_PAGE_TITLE;
  const logoSrc = hanziApp ? IconHanzi : IconQilu;

  useEffect(() => {
    document.title = pageTitle;
    JsBridge.setNavigationBar(
      JSON.stringify({ visible: true, showShare: false })
    );
  }, [pageTitle]);

  return (
    <div className="flex flex-col items-center ml-[20px] mr-[20px]">
      <img
        src={logoSrc}
        alt="logo"
        className="object-cover w-[90px] h-[90px] mt-[32px] mb-[32px]"
      />
      <div className="flex flex-col text-[#333333] text-[14px] font-normal">
        {hanziApp ? HANZI_INTRO : SDUCK_INTRO}
      </div>
      <div className="text-[#333333] text-[14px] font-normal">
        上海进步少年科技发展有限公司 版权所有
      </div>
      <div className="text-[#333333] text-[14px] font-normal mb-[20px]">
        沪ICP备2024107815号-2A
      </div>
    </div>
  );
}

export default AboutApp;
